import { lazy, Suspense } from "react";
import { DeferredAppMount } from "@/components/DeferredAppMount";

const Footer = lazy(() => import("@/components/Footer"));

export const DeferredFooter = () => (
  <DeferredAppMount delay={1200} timeout={3000}>
    <Suspense fallback={null}>
      <Footer />
    </Suspense>
  </DeferredAppMount>
);
